import { useEffect } from "react";
import { Loader2 } from "lucide-react";

function ensureCalLoaded() {
  if (window.Cal) return;
  (function (C, A, L) {
    let p = function (a, ar) { a.q.push(ar); };
    let d = C.document;
    C.Cal = C.Cal || function () {
      let cal = C.Cal;
      let ar = arguments;
      if (!cal.loaded) {
        cal.ns = {};
        cal.q = cal.q || [];
        d.head.appendChild(d.createElement("script")).src = A;
        cal.loaded = true;
      }
      if (ar[0] === L) {
        const api = function () { p(api, arguments); };
        const namespace = ar[1];
        api.q = api.q || [];
        if (typeof namespace === "string") {
          cal.ns[namespace] = cal.ns[namespace] || api;
          p(cal.ns[namespace], ar);
          p(cal, ["initNamespace", namespace]);
        } else p(cal, ar);
        return;
      }
      p(cal, ar);
    };
  })(window, "https://app.cal.com/embed/embed.js", "init");
}

export default function CalEmbed({ namespace, calLink, height = 680 }) {
  useEffect(() => {
    ensureCalLoaded();
    const theme = document.documentElement.classList.contains("dark") ? "dark" : "light";
    window.Cal("init", namespace, { origin: "https://app.cal.com" });
    window.Cal.config = window.Cal.config || {};
    window.Cal.config.forwardQueryParams = true;
    window.Cal.ns[namespace]("inline", {
      elementOrSelector: `#my-cal-inline-${namespace}`,
      config: { layout: "month_view", useSlotsViewOnSmallScreen: "true", theme },
      calLink,
    });
    window.Cal.ns[namespace]("ui", {
      hideEventTypeDetails: false,
      layout: "month_view",
      theme,
      styles: { branding: { brandColor: "#1E4D45" } },
    });
  }, [namespace, calLink]);

  return (
    <div className="relative overflow-hidden rounded-3xl border border-border bg-card shadow-soft">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
        <Loader2 className="h-6 w-6 animate-spin text-sage" />
      </div>
      <div
        id={`my-cal-inline-${namespace}`}
        data-testid={`cal-embed-${namespace}`}
        style={{ width: "100%", height, overflow: "scroll" }}
        className="relative"
      />
    </div>
  );
}
